import React from "react";
import Checkbox from "rc-checkbox";

/* Shared pieces of UploadUsersModal.jsx, extracted so each one is written once.
   A pure de-dup: the markup below is character-for-character the original. */

/* The two step-2 card checkboxes render the same row; only the state and the
   label differ, so the markup lives here once. */
export const UploadCheckboxRow = ({ checked, onChange, label, rowClass }) => {
  /* rowClass is inert outside .bwai-upload-modal, so the non-bwai mounts keep
     the class list they have today. */
  let className = "text-center font-weight-bold my-2";
  if (rowClass) {
    className = `${className} ${rowClass}`;
  }
  return (
    <div className={className}>
      <Checkbox className="ml-0" checked={checked} onChange={onChange} />
      {label}
    </div>
  );
};

/* The two step-1 red notes share one wrapper; only the copy differs. Inline
   styles are kept verbatim so the non-bwai mounts render identically. */
export const UploadDangerNote = ({ children }) => (
  <div
    style={{ fontSize: "12px", marginTop: "24px" }}
    className="text-danger bwai-upload-note"
  >
    {children}
  </div>
);

/* Three states, so if/else rather than a nested ternary. "Included" is an
   unmatched column the user ticked into the upload: neutral, not an error. */
export const UploadColumnCaption = ({ matched, isIncluded }) => {
  if (matched) {
    return <span className="matched-column-txt">(matched column)</span>;
  }
  if (isIncluded) {
    /* .matched-column-txt carries the neutral 16px baseline the siblings use
       (MatchColumn.css:43-50); the hook class re-tints it inside bwai. */
    return (
      <span className="matched-column-txt bwai-upload-included-txt">
        (included in upload)
      </span>
    );
  }
  return <span className="unmatched-column-txt">(unmatched column)</span>;
};
